(function Module() {
	'use strict';

	mySynch.controller('ErrorController', [
		'MySynchFactory',
		'clientLoggerService',
		function ErrorController(MSF, log) {
			MSF.ready(function onReady() {
				MSF.loadPage('Login');
			});
		}
	]);
})();
